import * as React from 'react';

import { compose } from 'recompose';

import user from 'js/lib/user';

import { NotFound as NotFoundPage } from 'bundles/common/components/withNotFound';
import { allContractsHardPausedOrTerminated } from 'bundles/enterprise-admin-contracts';
import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';
import Naptime from 'bundles/naptimejs';
import type { InjectedNaptime } from 'bundles/naptimejs';
import ProgramArchivedDenyModal from 'bundles/program-home/components/modals/ProgramArchivedDenyModal';
import { NotFoundError } from 'bundles/ssr/lib/errors/directives';
import inServerContext from 'bundles/ssr/util/inServerContext';
import {
  useEnterpriseContracts,
  useIsProgramLoading,
  useProgram,
} from 'bundles/unified-common/contexts/EnterpriseProgramContext';

type Props = {
  naptime?: InjectedNaptime;
  children: React.ReactNode;
};

// Checks data required to serve an enterprise page, if said data is not present returns appropriate error page.
export const EnterprisePageGuard = ({ children, naptime }: Props) => {
  const program = useProgram();
  const enterpriseContracts = useEnterpriseContracts();
  const isProgramLoading = useIsProgramLoading();

  // Show program archived page if program is archived.
  if (
    !isProgramLoading &&
    program &&
    (program?.metadata.endedAt ||
      (EnterpriseExperiments.get('enableNoActiveContractsPage') &&
        enterpriseContracts &&
        allContractsHardPausedOrTerminated(enterpriseContracts)))
  ) {
    return <ProgramArchivedDenyModal userId={user.get()?.id} naptime={naptime} />;
  }

  // If no program found, render NotFound page.
  if (!isProgramLoading && !program) {
    if (inServerContext) {
      throw new NotFoundError();
    } else {
      return <NotFoundPage />;
    }
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default compose<Props, {}>(Naptime.createContainer(() => ({})))(EnterprisePageGuard);
